import React, { useMemo, useState } from "react";
import { format } from "date-fns";
import Table from "../../../components/ui/table/Table";
import { downloadLoader } from "../../../assetData/loaders";

const getRowDate = (row) =>
  row.date || row.Date || row.TradDt || row.trade_date || row.import_date;

const IndicesConfig = ({ tableData, buttonConfig, loading, exchange }) => {
  const [loadingRows, setLoadingRows] = useState({});

  const handleReload = async (date, rowId) => {
    setLoadingRows((prev) => ({ ...prev, [rowId]: true }));

    const res = await buttonConfig?.handleReload(date);
    if (res) {
      setLoadingRows((prev) => {
        const { [rowId]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "date",
        accessorFn: (row) => getRowDate(row),
        header: "DATE",
        sortingFn: "datetime",
        Cell: ({ row }) => {
          const date = getRowDate(row.original);
          return date ? format(new Date(date), "dd MMM yyyy") : "-";
        },
      },
      {
        id: "weekday",
        accessorFn: (row) => row.Weekday || row.weekday || row.day || "-",
        header: "WEEKDAY",
      },
      {
        id: "exchange",
        accessorFn: (row) => row.exchange || row.Exchange || exchange,
        header: "EXCHANGE",
      },
      {
        id: "recordCount",
        accessorFn: (row) =>
          row.RecordCount || row.record_count || row.recordCount || row.count || 0,
        header: "# OF RECORDS",
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },
      {
        id: "status",
        accessorFn: (row) => row.Status || row.status || "-",
        header: "STATUS",
      },
      {
        id: "reload",
        header: "ACTIONS",
        Cell: ({ row }) => {
          const isLoading = !!loadingRows[row.id];
          const status = row.original.Status || row.original.status;
          const isSuccess = status === "Success" || status === "success";
          const disabled = isLoading || isSuccess;

          return (
            <button
              className={`flex h-[25px] w-[70px] items-center justify-center rounded bg-pri-clr-orange px-2 py-1 text-white transition hover:brightness-95 ${
                disabled ? "opacity-[75%]" : ""
              }`}
              onClick={() => handleReload(getRowDate(row.original), row.id)}
              disabled={disabled}
            >
              {isLoading ? (
                <img
                  src={downloadLoader}
                  className="px-2 py-1 text-white brightness-200"
                  alt="loader"
                />
              ) : (
                "RELOAD"
              )}
            </button>
          );
        },
      },
    ],
    [loadingRows, exchange],
  );

  return (
    <Table
      tableData={tableData}
      columns={columns}
      loading={loading}
      pageName={"Indices"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
    />
  );
};

export default IndicesConfig;
